import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

type MapState = {
	selectedLocation: { lat: number; lng: number } | null;
	watchLocation: boolean;
	locationModalInfoVisible: boolean;
};

export const initialState: MapState = {
	selectedLocation: null,
	watchLocation: false,
	locationModalInfoVisible: true,
};

const mapSlice = createSlice({
	name: "map",
	initialState,
	reducers: {
		setSelectedLocation: (state, action: PayloadAction<{ lat: number; lng: number } | null>) => {
			state.selectedLocation = action.payload;
		},
		setWatchLocation: (state, action: PayloadAction<boolean>) => {
			state.watchLocation = action.payload;
		},
		setLocationModalInfoVisible: (state, action) => {
			state.locationModalInfoVisible = action.payload;
		},
	},
});

export const { setSelectedLocation, setWatchLocation, setLocationModalInfoVisible } = mapSlice.actions;

export const getWatchLocation = (state: RootState) => state.mapReducer.watchLocation;
export const getSelectedLocation = (state: RootState) => state.mapReducer.selectedLocation;
export const getLocationModalInfoVisible = (state: RootState) => state.mapReducer.locationModalInfoVisible;

export default mapSlice.reducer;
